export var mutations = {
    brandingSettingsLoaded: function (state, settings) {
        state.branding = settings;
    },
    setPrivacyPolicy: function (state, url) {
        state.privacyPolicy = url;
    },
};
export var types = {
    BRANDING_SETTINGS_RETRIEVED: 'brandingSettingsLoaded',
    SET_PRIVACY_POLICY: 'setPrivacyPolicy',
};
